import usermanagementfilter from "../modules/usersManagement/UserManagementFilter";

export async function checkSuperAdminSession() {
  try {
    const session = await usermanagementfilter.getUserSessionData();
    return session === "superadmin";
  } catch {
    return false;
  }
}
